import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { InstanceDeserializer } from '@gametailors/lp-studio-connector';
import { LpInstance } from '../typings/schema';
import { routes } from './app.routes';
import { STUDIO_API_DATA_PACKAGE_PROVIDER } from './leerplus/rid-game.provider';
import { PronunciationService } from './services/pronunciation.service';
import { TextsService } from './services/texts.service';

async function initializeAppData() {
  const $pronunciationService = inject(PronunciationService);
  const $textsService = inject(TextsService);

  const datapackageProvider = STUDIO_API_DATA_PACKAGE_PROVIDER;
  const [schema, files, dataPackage] = await Promise.all([
    datapackageProvider.getSchema(),
    datapackageProvider.getFileMetas(),
    datapackageProvider.getDataPackage(),
  ]);
  const instances = new InstanceDeserializer<LpInstance>(schema, files, dataPackage.variables).deserializeMany(dataPackage.instances);
  await Promise.all([
    $pronunciationService.initialize(instances),
    $textsService.initialize(instances.filter((i) => i.dataType === 'RIDTexts')),
  ]);
}

export const appConfig: ApplicationConfig = {
  providers: [
    PronunciationService,
    TextsService,
    provideAnimations(), // for leerplus
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAppInitializer(initializeAppData),
  ],
};
